/* ==========================================================================
   Sanalvia Shilajit Gummies · JS de la landing
   Vanilla, sin dependencias. Cargado con defer.
   Responsabilidades:
     1. Acordeón FAQ accesible
     2. Sincronización del pack elegido con la barra sticky
     3. Visibilidad de la barra sticky en móvil
     4. Scroll suave a la zona de oferta
   ========================================================================== */
(function () {
  'use strict';

  var PREFERS_REDUCED = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  /* ---------------------------------------------------------------- FAQ -- */

  function initAccordions(root) {
    var groups = (root || document).querySelectorAll('[data-sv-accordion]');

    groups.forEach(function (group) {
      if (group.dataset.svAccordionReady === '1') return;
      group.dataset.svAccordionReady = '1';

      var singleOpen = group.dataset.svAccordion === 'single';
      var buttons = group.querySelectorAll('[data-sv-accordion-trigger]');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (!panel) return;

          var isOpen = btn.getAttribute('aria-expanded') === 'true';

          if (singleOpen && !isOpen) {
            buttons.forEach(function (other) {
              if (other === btn) return;
              var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
              other.setAttribute('aria-expanded', 'false');
              if (otherPanel) otherPanel.hidden = true;
            });
          }

          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          panel.hidden = isOpen;
        });
      });
    });
  }

  /* ------------------------------------------------------------- Packs -- */

  function currentPack() {
    var checked = document.querySelector('[data-sv-buybox] .sv-pack__input:checked');
    if (!checked) {
      checked = document.querySelector('[data-sv-buybox] .sv-pack__input');
    }
    return checked;
  }

  function syncSticky() {
    var bar = document.querySelector('[data-sv-sticky]');
    if (!bar) return;

    var pack = currentPack();
    if (!pack) return;

    var priceEl = bar.querySelector('[data-sv-sticky-price]');
    var titleEl = bar.querySelector('[data-sv-sticky-title]');

    if (priceEl && pack.dataset.svPrice) priceEl.textContent = pack.dataset.svPrice;
    if (titleEl && pack.dataset.svTitle) titleEl.textContent = pack.dataset.svTitle;
  }

  function initPacks(root) {
    var inputs = (root || document).querySelectorAll('[data-sv-buybox] .sv-pack__input');

    inputs.forEach(function (input) {
      if (input.dataset.svPackReady === '1') return;
      input.dataset.svPackReady = '1';

      input.addEventListener('change', function () {
        if (!input.checked) return;

        // Mantiene todos los selectores de la página en el mismo pack.
        var value = input.value;
        document.querySelectorAll('[data-sv-buybox] .sv-pack__input').forEach(function (other) {
          if (other !== input && other.value === value) other.checked = true;
        });

        // Actualiza el destino de los CTA de respaldo.
        var link = input.dataset.svLink;
        if (link) {
          document.querySelectorAll('[data-sv-cta]').forEach(function (cta) {
            cta.setAttribute('href', link);
          });
        }

        syncSticky();
      });
    });

    // Garantiza que siempre haya un pack marcado.
    document.querySelectorAll('[data-sv-buybox] .sv-packs').forEach(function (group) {
      var opts = group.querySelectorAll('.sv-pack__input');
      if (!opts.length) return;
      var any = Array.prototype.some.call(opts, function (o) {
        return o.checked;
      });
      if (!any) opts[opts.length - 1].checked = true;
    });

    syncSticky();
  }

  /* ------------------------------------------------------ Sticky CTA -- */

  function initSticky() {
    var bar = document.querySelector('[data-sv-sticky]');
    if (!bar || bar.dataset.svStickyReady === '1') return;
    bar.dataset.svStickyReady = '1';

    // Referencia: el bloque de compra del hero. Así la barra aparece justo
    // cuando el cliente deja atrás la primera oferta, no al final del hero.
    var afterSelector = bar.dataset.svStickyAfter || '#sv-hero';
    var anchor =
      document.querySelector(afterSelector + ' .sv-buybox') ||
      document.querySelector(afterSelector) ||
      document.querySelector('.sv-buybox');

    function anchorPassed() {
      if (!anchor) return window.scrollY > 600;
      var rect = anchor.getBoundingClientRect();
      return rect.bottom < 0;
    }

    var ticking = false;
    function update() {
      ticking = false;
      bar.classList.toggle('is-visible', anchorPassed());
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();

    // Oculta la barra cuando ya hay un punto de compra en pantalla: la zona de
    // oferta o el bloque de compra del producto. Evita tapar el botón real.
    var zones = [];
    var offer = document.querySelector('#sv-oferta');
    if (offer) zones.push(offer);

    var buyArea =
      document.querySelector('product-info [id^="ProductInfo-"]') ||
      document.querySelector('[id^="ProductInfo-"]');
    if (buyArea) zones.push(buyArea);

    if (zones.length && 'IntersectionObserver' in window) {
      var visible = [];
      var zoneObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var i = visible.indexOf(entry.target);
            if (entry.isIntersecting && i === -1) visible.push(entry.target);
            if (!entry.isIntersecting && i !== -1) visible.splice(i, 1);
          });
          bar.classList.toggle('is-suppressed', visible.length > 0);
        },
        { threshold: 0.2 }
      );
      zones.forEach(function (zone) {
        zoneObserver.observe(zone);
      });
    }
  }

  /* --------------------------------------------------- Scroll suave -- */

  /* Anclas virtuales hacia la sección de producto nativa de Shopify.
     No podemos añadir un id dentro de main-product sin tocarla, así que
     resolvemos el destino por selector:
       #sv-producto -> principio de la sección de producto (galería incluida)
       #sv-comprar  -> bloque de información y compra (título, packs, botón)
     Si la sección no existe (por ejemplo en una página suelta), se cae con
     elegancia a la sección de oferta. */
  function productTarget(kind) {
    if (kind === '#sv-comprar') {
      return (
        document.querySelector('product-info [id^="ProductInfo-"]') ||
        document.querySelector('[id^="ProductInfo-"]') ||
        document.querySelector('product-info[id^="MainProduct-"]')
      );
    }
    return (
      document.querySelector('product-info[id^="MainProduct-"]') ||
      document.querySelector('[id^="MainProduct-"]')
    );
  }

  function resolveTarget(id) {
    if (id === '#sv-producto' || id === '#sv-comprar') {
      return productTarget(id) || document.querySelector('#sv-oferta');
    }
    return document.querySelector(id);
  }

  function initSmoothScroll() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#sv-"]');
      if (!link) return;

      var id = link.getAttribute('href');
      if (!id || id === '#') return;

      var target = resolveTarget(id);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({
        behavior: PREFERS_REDUCED ? 'auto' : 'smooth',
        block: 'start'
      });

      // Foco accesible en el destino. En la sección de producto no movemos el
      // foco: los formularios de compra y de Releasit gestionan el suyo.
      var focusable = null;
      if (id !== '#sv-producto' && id !== '#sv-comprar') {
        focusable = target.querySelector('input, button, a, [tabindex]');
      }
      if (focusable) {
        window.setTimeout(function () {
          focusable.focus({ preventScroll: true });
        }, PREFERS_REDUCED ? 0 : 520);
      }
    });
  }

  /* -------------------------------------------------------- Arranque -- */

  function init(root) {
    initAccordions(root);
    initPacks(root);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
      initSmoothScroll();
    });
  } else {
    init(document);
    initSmoothScroll();
  }

  // Reinicialización dentro del editor de temas de Shopify.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var input = event.target.querySelector('.sv-pack__input');
    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();
